<template>
  <ul class="swatches">
    <li v-for="(color, index) in colors" :key="index">
      <label
        :qaid="`color-swatch-label-${color}`"
        class="swatch"
        :class="{'cursor-default' : displayOnly}"
        :for="`${radioName}-swatch-${color}`"
        :title="color"
      >
        <input
          type="radio"
          :aria-label="`${color} swatch`"
          class="swatch__radio"
          :data-color="color"
          data-id="#"
          data-url="#"
          :id="`${radioName}-swatch-${color}`"
          :name="radioName"
          :value="color"
          v-model="active"
          @change="onChange"
          :disabled="displayOnly"
        />
        <span
          class="swatch__decorator"
          :class="[displayOnly ? 'cursor-default' : '', `swatch-${color}`]"
        ></span>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    displayOnly: Boolean,
    changecolor: Function,
    activeColor: String,
    colors: {
      type: Array,
      default: function() {
        return [
          'red',
          'tan',
          'greenlight',
          'white',
          'green',
          'orange',
          'pink',
          'black',
          'greendark',
          'grey_reflective',
          'greylight',
          'bronze',
          'greenlight_grey',
          'bluelight',
          'greenvisibility',
        ];
      },
    },
    radioName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      active: this.activeColor ? this.activeColor : !this.displayOnly ? this.colors[0] : null,
    };
  },

  mounted() {
    this.onChange();
  },

  methods: {
    onChange(event) {
      if (this.changecolor) {
        this.changecolor(this.active);
      }
      this.$emit('color-changed', this.active);
    },
  },
};
</script>
